export default __webpack_public_path__ + "static/media/icon-16.757d06f8.png";